<template>
  <div class="info-page">
    <crumbs title="账号管理" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="auto"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>账号信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="账号名称" prop="account">
              <el-input
                v-model="form.account"
                placeholder="请输入账号名称"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isAdd" :gutter="10">
          <el-col :span="12">
            <el-form-item label="账号密码" prop="secret">
              <el-input
                v-model="form.secret"
                placeholder="请输入账号密码"
                maxlength="32"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <span class="random" @click="handleRandomSecret">随机生成</span>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="form.userName"
                placeholder="请输入姓名"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门" prop="departmentID">
              <enumerate
                v-model="form.departmentID"
                placeholder="请选择部门"
                url="/api/department/getdepartmentidname"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="职位" prop="workTitle">
              <el-input
                v-model="form.workTitle"
                placeholder="请输入职位"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phoneNumber">
              <el-input
                v-model="form.phoneNumber"
                placeholder="请输入手机号"
                maxlength="11"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="选择角色" prop="adminRoleId">
              <el-checkbox-group v-model="form.adminRoleId">
                <el-checkbox
                  v-for="(item, key) in roleList"
                  :key="key"
                  :label="item.code"
                  >{{ item.description }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="启用状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="备注信息" prop="description">
              <el-input
                v-model="form.description"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入备注信息"
                maxlength="2000"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="submit fn-text-center mt-20">
      <template v-if="isAdd">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAddData('ruleForm')"
          >提交</el-button
        >
      </template>
      <template v-else>
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerModifyData('ruleForm')"
          >提交</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
import CheckObj from "@/utils/check.js";
import { generatePassword } from "@/utils/public.js";
export default {
  name: "accountInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      //表单
      form: {
        account: "",
        secret: "",
        userName: "",
        departmentID: "",
        workTitle: "",
        phoneNumber: "",
        adminRoleId: [],
        status: 1,
        description: ""
      },
      rules: {
        account: [
          isEmpty("请输入账号名称"),
          {
            validator: (rule, value, callback) => {
              // 校验格式
              if (!/\w{6,20}/.test(value)) {
                return callback(
                  new Error("请输入由数字、字母组成且长度为6~20的账号")
                );
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        secret: [
          isEmpty("请输入账号密码"),
          {
            validator: (rule, value, callback) => {
              // 校验长度
              if (!/.{6,32}/.test(value)) {
                return callback(new Error("请输入长度为6~32的密码"));
              }
              // // 校验复杂度
              // const complex = [
              //   /[a-zA-Z]/.test(value),
              //   /[0-9]/.test(value),
              //   /[^a-zA-Z0-9]/.test(value)
              // ].reduce((acc, cur) => {
              //   return acc + (cur ? 1 : 0);
              // }, 0);
              // if (complex < 2) {
              //   return callback(
              //     new Error("数字、大小写字母和特殊字符最少包含两种")
              //   );
              // }
              callback();
            },
            trigger: "blur"
          }
        ],
        userName: [isEmpty("请输入姓名")],
        departmentID: [isEmpty("请选择部门", "change")],
        workTitle: [isEmpty("请输入职位")],
        phoneNumber: [
          isEmpty("请输入手机号"),
          {
            validator: (rule, value, callback) => {
              if (!CheckObj.checkPhone(value)) {
                return callback(new Error("请输入正确的手机号"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        adminRoleId: [isEmpty("请选择角色", "change")],
        status: [isEmpty("请选择启用状态", "change")]
      },
      roleList: []
    };
  },
  created() {
    this.loadRoleList();
    const { method } = this.$route.params;
    // 默认值 走添加流程
    let isAdd = true;
    if (method === "modification") {
      //获取信息
      this.loadInfo();
      // this.$nextTick(() => {});
      //走修改流程
      isAdd = false;
    }
    this.isAdd = isAdd;
  },
  methods: {
    loadRoleList() {
      this.$api("privilege", "getRoleEnumerate", {}).then((res) => {
        // console.log(res);
        this.roleList = res.dataList;
      });
    },
    handleRandomSecret() {
      this.form.secret = generatePassword();
    },
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // list
        ...others
      } = this.form;
      return {
        ...others
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const { ...others } = data;
      return {
        ...others
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("privilege", "addAccount", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("privilege", "addAccount", {
        ...params,
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("privilege", "getAccountInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.dataList[0]);
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/systemManage/accountList`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.info-page {
  .el-checkbox {
    vertical-align: top;
  }
  .random {
    line-height: 40px;
    font-size: 14px;
    color: #409eff;
    cursor: pointer;
  }
}
</style>
